import { Select, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { getFullName } from "../../../helpers/stringHelper";
import { useAdmin } from "../../../hooks/useProps";
import type { Coach } from "../../../models/coach";
import { getStatusOptions, type Status } from "../../../models/enums/status";
import type { Report } from "../../../models/reports/report";
import { FilterSelect } from "../../select/FilterSelect";

type CommonReportFormProps<T extends CommonReportFormType> = {
  form: UseFormReturnType<T>;
  report: Report;
  errors: CommonReportFormErrors;
  coaches: Coach[];
};

export type CommonReportFormType = {
  title: string;
  status: Status;
  responsible_coach_id: string;
};

export type CommonReportFormErrors = {
  title?: string[];
  status?: string[];
  responsible_coach?: string[];
};

export function CommonReportForm<T extends CommonReportFormType>({ form, report, errors, coaches }: CommonReportFormProps<T>) {
  const isAdmin = useAdmin();
  return (
    <>
      <TextInput label="Lernende/r" disabled={true} value={getFullName(report.apprentice)} />
      <TextInput label="Gruppe" disabled={true} value={report.apprentice.group.name} />
      <TextInput withAsterisk label="Titel" key={form.key("title")} {...form.getInputProps("title")} error={errors?.title} />
      <Select
        label="Status"
        withAsterisk
        data={getStatusOptions()}
        key={form.key("status")}
        {...form.getInputProps("status")}
        error={errors?.status}
      />

      {isAdmin && (
        <FilterSelect
          withAsterisk
          label="Zuständiger Coach"
          data={coaches.map((coach) => ({
            value: coach.id.toString(),
            label: getFullName(coach),
          }))}
          {...form.getInputProps("responsible_coach_id")}
          error={errors?.responsible_coach}
        />
      )}
    </>
  );
}
